// extracted by mini-css-extract-plugin
export default {"FooterContainer":"Footer_FooterContainer__MAqfG","LogoIcon":"Footer_LogoIcon__pL4kX","Icon":"Footer_Icon__9aJTj"};